import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block-number-value" }

import { computed } from "vue";


const __default__ = {
  name: "QueueBlocksWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    queueData: {},
    queueConfig: {},
    borderRadius: {},
    config: {},
    numberTxt: {},
    counterTxt: {}
  },
  setup(__props: any) {

const props = __props;

const qc = computed(() => props.config?.queueConfig || props.queueConfig || {});

const DEFAULT_COUNTER_LABELS: Record<string, string> = {
  en: "Counter",
  fr: "Guichet",
  ar: "شباك",
};

const DEFAULT_NUMBER_LABELS: Record<string, string> = {
  en: "Number",
  fr: "Numéro",
  ar: "رقم",
};

const headerLanguages = computed(() => {
  const langs = qc.value.headerLanguages;
  return Array.isArray(langs) && langs.length > 0 ? langs : ["fr", "ar"];
});

function getBlockLabel(lang: string, type: "counter" | "number"): string {
  const byLang = qc.value.blocksLabelsByLang;
  if (byLang && typeof byLang === "object" && byLang[lang]?.[type]) {
    return String(byLang[lang][type]);
  }
  const defaults =
    type === "counter" ? DEFAULT_COUNTER_LABELS : DEFAULT_NUMBER_LABELS;
  return defaults[lang] ?? defaults.en;
}

const counterLabels = computed(() =>
  headerLanguages.value.map((lang: string) => ({
    lang,
    text: getBlockLabel(lang, "counter"),
  }))
);

const numberLabels = computed(() =>
  headerLanguages.value.map((lang: string) => ({
    lang,
    text: getBlockLabel(lang, "number"),
  }))
);

const widgetWidth = computed(() => props.config?.width || 400);
const widgetHeight = computed(() => props.config?.height || 400);
const rowGap = 12;

const displayRows = computed(() => {
  const data = props.queueData ?? [];
  if (!props.config?.queueConfig?.multipleRows) {
    return data.slice(0, 1);
  }
  return data;
});

const rowCount = computed(() => Math.max(displayRows.value.length, 1));
const isFewRows = computed(() => rowCount.value <= 2);

const availableHeight = computed(() => {
  const gaps = Math.max(0, rowCount.value - 1) * rowGap;
  return widgetHeight.value - gaps;
});

const cardHeight = computed(() => availableHeight.value / rowCount.value);

const borderRadiusCss = computed(() => {
  const r = props.borderRadius ?? props.config?.borderRadius ?? 10;
  return typeof r === "number" ? `${r}px` : String(r);
});

const headerFontSize = computed(() => {
  const raw = qc.value.headerFontSize;
  if (
    raw !== undefined &&
    raw !== null &&
    raw !== 0 &&
    raw !== "0" &&
    raw !== ""
  ) {
    return Number(raw);
  }
  const w = widgetWidth.value;
  const h = cardHeight.value * 0.32;
  return Math.max(14, Math.min(48, Math.min(w * 0.055, h * 0.42)));
});

const contentFontSize = computed(() => {
  const raw = qc.value.contentFontSize;
  if (
    raw !== undefined &&
    raw !== null &&
    raw !== 0 &&
    raw !== "0" &&
    raw !== ""
  ) {
    return Number(raw);
  }
  const w = widgetWidth.value;
  const bodyH = cardHeight.value * 0.68;
  const displayH = bodyH * 0.55;
  return Math.max(22, Math.min(120, Math.min(displayH * 0.55, w * 0.14)));
});

const badgeFontSize = computed(() => {
  const base = contentFontSize.value;
  return Math.max(18, Math.min(base, base * 0.85));
});

const rootStyle = computed(() => ({
  gap: `${rowGap}px`,
}));

const cardStyle = computed(() => ({
  borderColor: qc.value.numberHeaderColor || "#0132ab",
  borderRadius: borderRadiusCss.value,
  minHeight: isFewRows.value ? `${cardHeight.value * 0.45}px` : undefined,
}));

const headerStyle = computed(() => ({
  backgroundColor: qc.value.counterBgColor || "#0032ad",
  borderTopLeftRadius: borderRadiusCss.value,
  borderTopRightRadius: borderRadiusCss.value,
  minHeight: isFewRows.value ? `${cardHeight.value * 0.25}px` : `${Math.max(48, cardHeight.value * 0.32)}px`,
}));

const headerLabelStyle = computed(() => ({
  color: qc.value.counterTxtColor || "#ffffff",
  fontSize: `${headerFontSize.value}px`,
}));

const counterBadgeStyle = computed(() => ({
  color: qc.value.counterTxtColor || "#ffffff",
  borderColor: qc.value.counterTxtColor || "#ffffff",
  fontSize: `${badgeFontSize.value}px`,
  borderRadius: borderRadiusCss.value,
}));

const bodyStyle = computed(() => ({
  backgroundColor: qc.value.numberBgColor || "#ffffff",
  borderBottomLeftRadius: borderRadiusCss.value,
  borderBottomRightRadius: borderRadiusCss.value,
}));

const numberLabelStyle = computed(() => ({
  color: qc.value.numberHeaderColor || "#0132ab",
  fontSize: `${headerFontSize.value}px`,
}));

const numberDisplayStyle = computed(() => ({
  borderColor: qc.value.numberHeaderColor || "#0132ab",
  color: qc.value.numberTxtColor || "#0132ab",
  fontSize: `${contentFontSize.value}px`,
  borderRadius: borderRadiusCss.value,
  backgroundColor: qc.value.numberBgColor || "#ffffff",
}));

return (_ctx: any,_cache: any) => {
  return (displayRows.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "blocks-root",
        style: _normalizeStyle(rootStyle.value)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayRows.value, (row, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.id || idx,
            class: _normalizeClass(["block-card", { 'few-rows': isFewRows.value }]),
            style: _normalizeStyle(cardStyle.value)
          }, [
            _createElementVNode("div", {
              class: "block-header",
              style: _normalizeStyle(headerStyle.value)
            }, [
              _createElementVNode("div", {
                class: "block-header-labels",
                style: _normalizeStyle(headerLabelStyle.value)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(counterLabels.value, (label) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: label.lang,
                    class: _normalizeClass(["block-label-line", { 'block-label-ar': label.lang === 'ar' }])
                  }, _toDisplayString(label.text), 3))
                }), 128))
              ], 4),
              _createElementVNode("div", {
                class: "block-counter-badge",
                style: _normalizeStyle(counterBadgeStyle.value)
              }, _toDisplayString(row.counter), 5)
            ], 4),
            _createElementVNode("div", {
              class: "block-body",
              style: _normalizeStyle(bodyStyle.value)
            }, [
              _createElementVNode("div", {
                class: "block-number-labels",
                style: _normalizeStyle(numberLabelStyle.value)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberLabels.value, (label) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: label.lang,
                    class: _normalizeClass({ 'block-label-ar': label.lang === 'ar' })
                  }, _toDisplayString(label.text), 3))
                }), 128))
              ], 4),
              _createElementVNode("div", {
                class: "block-number-display",
                style: _normalizeStyle(numberDisplayStyle.value)
              }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(row.ticket), 1)
              ], 4)
            ], 4)
          ], 6))
        }), 128))
      ], 4))
    : _createCommentVNode("", true)
}
}

})